'use client'

import { Alert, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import InfoIcon from '@/assets/icons/info-circle.svg'
import { I18nLink } from '@/i18n/navigation'

import styles from './styles.module.css'

interface DisclaimerProps {
  coinName: string
}

export default function Disclaimer({ coinName }: DisclaimerProps) {
  const t = useTranslations('disclaimer')

  const icon = <InfoIcon fill="var(--common-white)" />
  return (
    <Alert
      variant="light"
      color="blue"
      icon={icon}
      classNames={{
        root: styles.root,
        icon: styles.icon,
        message: styles.message,
      }}
    >
      <Text variant="subtitle">
        {t.rich('description', {
          coinName,
          priceIndex: (chunks: React.ReactNode) => (
            <I18nLink href="/price" style={{ color: 'var(--common-primary)' }}>
              {chunks}
            </I18nLink>
          ),
        })}
      </Text>
    </Alert>
  )
}
